import Http from '@/libs/http.js';

/**
 * 单点获取用户信息
 * @returns {Promise}
 */
export const sdtAppLogin = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/sdtAppLogin',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 获取菜单列表
 * @returns {Promise}
 */
export const getMenuList = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getMenuList',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 更新菜单列表
 * @returns {Promise}
 */
export const updateMenuList = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/updateMenuList',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 获取组织架构信息
 * @returns {Promise}
 */
export const getOrgInfo = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getOrgInfo',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};